<template>
  <el-table-column v-bind="$attrs">
    <template #default="{ row, column, $index }">
      <slot :row="row" :column="column" :$index="$index">
        <el-image v-if="row[$attrs.prop]" class="table-td-thumb" :src="row[$attrs.prop]" :preview-src-list="[img_zoom_clear(row[$attrs.prop])]" lazy preview-teleported></el-image>
        <slot name="addon" :row="row" :column="column" :$index="$index"></slot>
      </slot>
    </template>
  </el-table-column>
</template>

<script>
export default {
  name: "YmTableColumnThumb"
}
</script>
<script setup>
import { ElTableColumn, ElImage } from "element-plus";
import 'element-plus/dist/index.css'
import {img_zoom_clear} from "ym-js-box";
</script>

<style scoped>

</style>
